module.exports = __webpack_public_path__ + "static/media/IMG_1686.18128b9d.jpg";